import React from 'react';
import { styled } from '@linaria/react';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { StarRating } from '@daedalus/atlas/StarRating';
import { Text } from '@daedalus/atlas/Text';
import { ContentHotel } from '@findhotel/sapi/dist/types/packages/core/src';
import { HotelDetailsLoading } from './HotelDetailsLoading';

// Using an inline spacer to avoid issues with margin and a long title that wraps to the next line
const StarsSpacer = /*#__PURE__*/styled('span')({
  name: "StarsSpacer",
  class: "sofcyqj",
  propsAsIs: false
});
const HotelDetailsWrapper = /*#__PURE__*/styled('div')({
  name: "HotelDetailsWrapper",
  class: "hsvoyjx",
  propsAsIs: false
});
const StarsWrapper = /*#__PURE__*/styled('div')({
  name: "StarsWrapper",
  class: "sdxa443",
  propsAsIs: false
});
interface PropsTypes {
  hotel?: ContentHotel;
}
export const HotelDetails: React.FC<PropsTypes> = ({
  hotel
}) => {
  const {
    isMobile
  } = useDeviceLayout();

  // Show HotelDetails loading
  if (!hotel) return <HotelDetailsLoading />;
  if (isMobile) {
    return <HotelDetailsWrapper>
        <Text variant="titleL">
          {hotel.hotelName}
          <StarsSpacer />
          <StarRating size="xs" data-id="StarRating" rating={hotel.starRating} isInline />
        </Text>
      </HotelDetailsWrapper>;
  }
  return <>
      <StarsWrapper>
        <StarRating size="xs" data-id="StarRating" rating={hotel.starRating} isInline />
      </StarsWrapper>
      <Text variant="titleXL">
        {hotel.hotelName}
        <StarsSpacer />
      </Text>
    </>;
};

require("./HotelDetails.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./HotelDetails.tsx");